import SkeletonCardItems from './skeletonCardItems';
import './skeletonLoader.sass';

/** Muestra el estado de carga de las recomendaciones como carrusel horizontal. */
export default function NotesSkeletonLoader({
  count = 5,
  turnId = 'pending',
}) {
  const skeletonResultsId = `resultadosUTV-skeleton-${turnId}`;

  return (
    <section className="list-wrapper-results skeleton-notes skeleton-notes--mobile">
      <div
        id={skeletonResultsId}
        className="mobile-results-carousel skeleton-notes__carousel"
        role="region"
        aria-label="Cargando resultados relacionados"
        aria-busy="true"
      >
        <div className="mobile-results-carousel__track skeleton-notes__track">
          <SkeletonCardItems
            count={count}
            itemClassName="mobile-results-carousel__slide skeleton-notes__slide"
          />
        </div>
      </div>
    </section>
  );
}
